import _ from 'underscore'

import COUNTRIES from '../../utils/Countries.js'
import {ParcelCarrier} from './carrier.types.js'

const PostNLEUR1 = [
    'AT', 'BE', 'DE', 'DK', 'ES', 'FR', 'IT', 'LU', 'SE'
]

const PostNLEUR2 = [
    'AL', 'AD', 'BY', 'BA', 'BG', 'HR', 'CY', 'CZ', 'EE', 'FO', 'FI', 'GI',
    'GR', 'GL', 'HU', 'IS', 'IE', 'LV', 'LI', 'LT', 'MK', 'MT', 'MD', 'ME',
    'NO', 'PL', 'RO', 'PT', 'SM', 'RS', 'SK', 'SI', 'CH', 'TR', 'UA', 'VA'
]

const DHLCountries = ['AT', 'BE', 'BG', 'CH', 'CZ', 'DE', 'DK', 'EE', 'ES', 'FI', 'FR', 'GB', 'GR', 'HR', 'HU', 'IC', 'IE', 'IT', 'LI', 'LT', 'LU', 'LV', 'MC', 'NL', 'NO', 'PL', 'PT', 'RO', 'SE', 'SI', 'SK', 'SM']

const PostNLWereld = _.difference(_.pluck(COUNTRIES, 'code2'), _.union(PostNLEUR1, PostNLEUR2))

function generatecombinedProducts(carrier) {
    const combinedProducts = {'Standaard zending': carrier.countries}

    _.keys(carrier.products).sort().map((productName) => {
        combinedProducts[productName] = carrier.products[productName].countries

        carrier.products[productName].allowed.sort().map((allowedProductName) => {
            combinedProducts[[productName, allowedProductName].sort().join(', ')] = _.intersection(carrier.products[productName].countries, carrier.products[allowedProductName].countries)

            carrier.products[productName].allowed.sort().map((allowedProductName2) => {
                if (allowedProductName !== allowedProductName2 && carrier.products[allowedProductName].allowed.includes(allowedProductName2)) {
                    combinedProducts[[productName, allowedProductName, allowedProductName2].sort().join(', ')] = _.intersection(carrier.products[productName].countries, carrier.products[allowedProductName].countries, carrier.products[allowedProductName2].countries)

                    carrier.products[productName].allowed.sort().map((allowedProductName3) => {
                        if (_.unique([allowedProductName, allowedProductName2, allowedProductName3]).length === 3 &&
                            carrier.products[allowedProductName].allowed.includes(allowedProductName2) &&
                            carrier.products[allowedProductName].allowed.includes(allowedProductName3) &&
                            carrier.products[allowedProductName2].allowed.includes(allowedProductName3)) {
                            combinedProducts[[productName, allowedProductName, allowedProductName2, allowedProductName3].sort().join(', ')] = _.intersection(carrier.products[productName].countries, carrier.products[allowedProductName].countries, carrier.products[allowedProductName2].countries, carrier.products[allowedProductName3].countries)

                            carrier.products[productName].allowed.sort().map((allowedProductName4) => {
                                if (_.unique([allowedProductName, allowedProductName2, allowedProductName3, allowedProductName4]).length === 4 &&
                                    carrier.products[allowedProductName].allowed.includes(allowedProductName2) &&
                                    carrier.products[allowedProductName].allowed.includes(allowedProductName3) &&
                                    carrier.products[allowedProductName].allowed.includes(allowedProductName4) &&
                                    carrier.products[allowedProductName2].allowed.includes(allowedProductName3) &&
                                    carrier.products[allowedProductName2].allowed.includes(allowedProductName4) &&
                                    carrier.products[allowedProductName3].allowed.includes(allowedProductName4)) {
                                    combinedProducts[[productName, allowedProductName, allowedProductName2, allowedProductName3, allowedProductName4].sort().join(', ')] = _.intersection(carrier.products[productName].countries, carrier.products[allowedProductName].countries, carrier.products[allowedProductName2].countries, carrier.products[allowedProductName3].countries, carrier.products[allowedProductName4].countries)

                                    carrier.products[productName].allowed.sort().map((allowedProductName5) => {
                                        if (_.unique([allowedProductName, allowedProductName2, allowedProductName3, allowedProductName4, allowedProductName5]).length === 5 &&
                                            carrier.products[allowedProductName].allowed.includes(allowedProductName2) &&
                                            carrier.products[allowedProductName].allowed.includes(allowedProductName3) &&
                                            carrier.products[allowedProductName].allowed.includes(allowedProductName4) &&
                                            carrier.products[allowedProductName].allowed.includes(allowedProductName5) &&
                                            carrier.products[allowedProductName2].allowed.includes(allowedProductName3) &&
                                            carrier.products[allowedProductName2].allowed.includes(allowedProductName4) &&
                                            carrier.products[allowedProductName2].allowed.includes(allowedProductName5) &&
                                            carrier.products[allowedProductName3].allowed.includes(allowedProductName4) &&
                                            carrier.products[allowedProductName3].allowed.includes(allowedProductName5) &&
                                            carrier.products[allowedProductName4].allowed.includes(allowedProductName5)) {
                                            combinedProducts[[productName, allowedProductName, allowedProductName2, allowedProductName3, allowedProductName4, allowedProductName5].sort().join(', ')] = _.intersection(carrier.products[productName].countries, carrier.products[allowedProductName].countries, carrier.products[allowedProductName2].countries, carrier.products[allowedProductName3].countries, carrier.products[allowedProductName4].countries, carrier.products[allowedProductName5].countries)
                                        }
                                    })
                                }
                            })
                        }
                    })
                }
            })
        })
    })

    return combinedProducts
}

function generatecombinedProductValues(carrier) {
    const combinedProductsValues = JSON.parse(JSON.stringify(carrier.combinedProducts))

    _.keys(carrier.combinedProducts).sort().map((combinedProductName) => {
        const productNames = combinedProductName.split(', ')
        const combinedProduct = combinedProductsValues[combinedProductName]

        productNames.map((productName) => {
            if (carrier.products[productName] && carrier.products[productName].values) {
                delete combinedProductsValues[combinedProductName]

                carrier.products[productName].values.map((value) => {
                    const combinedProductValueName = [..._.difference(productNames, [productName]), `${productName} (${value})`].sort().join(', ')
                    combinedProductsValues[combinedProductValueName] = combinedProduct
                })
            }
        })
    })

    return combinedProductsValues
}

const carriers: {
    [key: string]: ParcelCarrier
} = {
    'Reseller': {
        type: 'partner',
        countries: [...PostNLEUR1, ...PostNLEUR2, ...PostNLWereld],
        products: {
            'Aangetekend': {
                allowed: ['Leeftijdscheck 18+', 'Postbus', 'Px', 'Retour bij niet thuis', 'Same Day'],
                countries: ['NL']
            },
            'Aangetekende brief': {
                type: 'product',
                allowed: ['Postbus', 'Px', 'Same Day'],
                countries: ['NL'],
                maxWeight: 2000,
                maxDimensions: {
                    length: 380,
                    width: 265,
                    height: 32
                }
            },
            'Adreslabel': {
                type: 'product',
                allowed: ['Postbus'],
                countries: _.pluck(COUNTRIES, 'code2')
            },
            'Brievenbuspakket': {
                type: 'product',
                allowed: ['Postbus', 'Px', 'Same Day'],
                countries: ['NL'],
                maxWeight: 2000,
                maxDimensions: {
                    length: 380,
                    width: 265,
                    height: 32
                }
            },
            'Brievenbuspakket zonder Track & Trace': {
                type: 'product',
                allowed: ['Postbus', 'Same Day'],
                countries: ['NL'],
                maxWeight: 2000,
                maxDimensions: {
                    length: 380,
                    width: 265,
                    height: 32
                }
            },
            'Envelop': {
                type: 'product',
                allowed: [],
                countries: ['NL'],
                maxWeight: 500,
                maxDimensions: {
                    length: 380,
                    width: 265,
                    height: 32
                }
            },
            'Handtekening voor ontvangst': {
                allowed: ['Leeftijdscheck 18+', 'Niet bij buren', 'Postbus', 'Px', 'Retour bij niet thuis', 'Same Day'],
                countries: ['NL']
            },
            'Leeftijdscheck 18+': {
                allowed: ['Aangetekend', 'Handtekening voor ontvangst', 'Niet bij buren', 'Postbus', 'Px', 'Same Day'],
                countries: ['NL']
            },
            'Niet bij buren': {
                allowed: ['Handtekening voor ontvangst', 'Leeftijdscheck 18+', 'Px', 'Retour bij niet thuis', 'Same Day'],
                countries: ['NL']
            },
            'Postbus': {
                allowed: ['Aangetekend', 'Aangetekende brief', 'Adreslabel', 'Brievenbuspakket', 'Brievenbuspakket zonder Track & Trace', 'Handtekening voor ontvangst', 'Leeftijdscheck 18+'],
                countries: ['NL']
            },
            'Px': {
                allowed: ['Aangetekend', 'Aangetekende brief', 'Brievenbuspakket', 'Handtekening voor ontvangst', 'Leeftijdscheck 18+', 'Niet bij buren', 'Retour bij niet thuis', 'Same Day'],
                countries: ['NL']
            },
            'Retour bij niet thuis': {
                allowed: ['Aangetekend', 'Handtekening voor ontvangst', 'Niet bij buren', 'Px', 'Same Day'],
                countries: ['NL']
            },
            'Same Day': {
                allowed: ['Aangetekend', 'Aangetekende brief', 'Niet bij buren', 'Brievenbuspakket', 'Brievenbuspakket zonder Track & Trace', 'Handtekening voor ontvangst', 'Leeftijdscheck 18+', 'Px', 'Retour bij niet thuis', 'Verspakket'],
                countries: ['NL']
            },
            'Verificatiecode': {
                allowed: ['Same Day'],
                countries: ['NL']
            },
            'Verspakket': {
                allowed: ['Same Day'],
                countries: ['NL']
            }
        }
    },
    'Bpost-QLS': {
        displayName: 'Bpost',
        type: 'external',
        platform: 'QLS',
        countries: ['BE'],
        maxWeight: 31500,
        maxDimensions: {
            length: 1200,
            width: 600,
            height: 500
        },
        maxVolume: 360,
        products: {
            Afhaalpunt: {
                allowed: ['Verzekerd'],
                countries: ['BE']
            },
            Retour: {
                type: 'product',
                countries: ['BE'], // For retour parcels the receiver address and sender address is swapped so this actually is the sender country
                allowed: []
            },
            Verzekerd: {
                countries: ['BE'],
                allowed: ['Afhaalpunt'],
                values: [500]
            }
        },
        logo: '/images/bpostLogo.png'
    },
    'Cycloon': {
        displayName: 'Cycloon',
        type: 'external',
        countries: _.pluck(COUNTRIES, 'code2'),
        maxWeight: 50000,
        maxDimensions: {
            length: 2400,
            width: 2000,
            height: 1000
        },
        maxVolume: 4800,
        products: {
            'Aangetekend': {
                allowed: ['Antwoordnummer', 'Postbus'],
                countries: ['NL']
            },
            'Aangetekende brief': {
                type: 'product',
                allowed: ['Antwoordnummer', 'Postbus'],
                countries: _.pluck(COUNTRIES, 'code2'),
                maxWeight: 2000,
                maxDimensions: {
                    length: 380,
                    width: 265,
                    height: 32
                }
            },
            'Antwoordnummer': {
                type: 'product',
                allowed: ['Aangetekend', 'Aangetekende brief', 'Brievenbuspakket', 'Handtekening voor ontvangst'],
                countries: ['NL']
            },
            'Brievenbuspakket': {
                type: 'product',
                allowed: ['Antwoordnummer', 'Postbus'],
                countries: ['NL', 'BE', 'DE', 'IT', 'FR', 'GB'],
                maxWeight: 2000,
                maxDimensions: {
                    length: 380,
                    width: 265,
                    height: 32
                }
            },
            'Handtekening voor ontvangst': {
                allowed: ['Antwoordnummer', 'Niet bij buren', 'Postbus'],
                countries: ['NL']
            },
            'Niet bij buren': {
                allowed: ['Handtekening voor ontvangst'],
                countries: ['NL']
            },
            'Postbus': {
                allowed: ['Aangetekend', 'Aangetekende brief', 'Brievenbuspakket', 'Handtekening voor ontvangst'],
                countries: ['BE', 'NL']
            }
        },
        logo: '/images/cycloonLogo.png'

    },
    'DHL': {
        displayName: 'DHL',
        type: 'external',
        countries: DHLCountries,
        maxWeight: 31500,
        maxDimensions: {
            length: 2400,
            width: 600,
            height: 600
        },
        maxVolume: 432,
        products: {
            'Aangetekend': {
                allowed: ['Avondlevering', 'Leeftijdscheck 18+', 'Same Day', 'Verzekerd'],
                countries: ['NL']
            },
            'Aangetekende brief': {
                type: 'product',
                allowed: [],
                countries: ['NL'],
                maxWeight: 2000,
                maxDimensions: {
                    length: 380,
                    width: 265,
                    height: 32
                }
            },
            'Afhaalpunt': {
                allowed: ['Verzekerd'],
                countries: ['BE', 'NL'],
                maxWeight: 20000,
                maxDimensions: {
                    length: 800,
                    width: 500,
                    height: 350
                }
            },
            'Avondlevering': {
                allowed: ['Aangetekend', 'Handtekening voor ontvangst', 'Leeftijdscheck 18+', 'Niet bij buren', 'Verzekerd'],
                countries: ['NL']
            },
            'Brievenbuspakket': {
                type: 'product',
                allowed: ['Same Day'],
                countries: ['NL', 'BE'],
                maxWeight: 2000,
                maxDimensions: {
                    length: 380,
                    width: 265,
                    height: 32
                }
            },
            'Envelop': {
                type: 'product',
                allowed: [],
                countries: ['NL'],
                maxWeight: 500,
                maxDimensions: {
                    length: 380,
                    width: 265,
                    height: 32
                }
            },
            'Handtekening voor ontvangst': {
                allowed: ['Avondlevering', 'Leeftijdscheck 18+', 'Niet bij buren', 'Same Day', 'Spoed levering', 'Verzekerd'],
                countries: ['NL', 'BE']
            },
            'Leeftijdscheck 18+': {
                allowed: ['Aangetekend', 'Avondlevering', 'Handtekening voor ontvangst', 'Niet bij buren', 'Same Day', 'Verzekerd'],
                countries: ['NL']
            },
            'Niet bij buren': {
                allowed: ['Avondlevering', 'Handtekening voor ontvangst', 'Leeftijdscheck 18+', 'Same Day', 'Spoed levering', 'Verzekerd'],
                countries: ['NL']
            },
            'Retour': {
                type: 'product',
                allowed: [],
                countries: ['AT', 'BE', 'BG', 'CZ', 'DE', 'DK', 'EE', 'ES', 'FI', 'FR', 'GR', 'HR', 'HU', 'IE', 'IT', 'LT', 'LU', 'LV', 'NL', 'PL', 'PT', 'RO', 'SE', 'SI', 'SK'] // For retour parcels the receiver address and sender address is swapped so this actually is the sender country
            },
            'Same Day': {
                allowed: ['Aangetekend', 'Brievenbuspakket', 'Handtekening voor ontvangst', 'Leeftijdscheck 18+', 'Niet bij buren', 'Verzekerd'],
                countries: ['NL']
            },
            'Spoed levering': {
                allowed: ['Handtekening voor ontvangst', 'Niet bij buren'],
                countries: ['NL', 'BE', 'LU'],
                values: ['12:00']
            },
            'Verzekerd': {
                allowed: ['Aangetekend', 'Afhaalpunt', 'Avondlevering', 'Handtekening voor ontvangst', 'Leeftijdscheck 18+', 'Same Day', 'Niet bij buren'],
                countries: DHLCountries,
                values: [500, 1000, 1500, 2000, 2500, 3000, 3500, 4000, 4500, 5000]
            }
        },
        logo: '/images/dhlLogo.png'
    },
    'DHL-europlus': {
        displayName: 'DHL Europlus',
        type: 'external',
        countries: ['NL', 'BE', 'LU'],
        maxWeight: 31500,
        maxDimensions: {
            length: 2400,
            width: 800,
            height: 600
        },
        maxVolume: 432,
        products: {
            'Aangetekend': {
                allowed: ['Verzekerd'],
                countries: ['NL']
            },
            'Handtekening voor ontvangst': {
                allowed: ['Niet bij buren', 'Verzekerd'],
                countries: ['NL', 'BE', 'LU']
            },
            'Niet bij buren': {
                allowed: ['Handtekening voor ontvangst', 'Verzekerd'],
                countries: ['NL', 'BE', 'LU']
            },
            'Spoed levering': {
                allowed: ['Handtekening voor ontvangst', 'Niet bij buren', 'Verzekerd'],
                countries: ['NL', 'BE', 'LU'],
                values: ['12:00']
            },
            'Verzekerd': {
                allowed: ['Handtekening voor ontvangst', 'Niet bij buren', 'Spoed levering'],
                countries: ['NL', 'BE', 'LU'],
                values: [500, 1000, 1500, 2000, 2500, 3000, 3500, 4000, 4500, 5000]
            }
        },
        logo: '/images/dhlEuroplusLogo.png'
    },
    'DHL-MSG': {
        displayName: 'DHL',
        type: 'external',
        platform: 'Monta',
        countries: DHLCountries,
        maxWeight: 31500,
        maxDimensions: {
            length: 1200,
            width: 600,
            height: 600
        },
        maxVolume: 360,
        products: {
            'Aangetekend': {
                allowed: [],
                countries: ['NL']
            },
            'Aangetekende brief': {
                type: 'product',
                allowed: [],
                countries: ['NL'],
                maxWeight: 2000,
                maxDimensions: {
                    length: 380,
                    width: 265,
                    height: 32
                }
            },
            'Brievenbuspakket': {
                type: 'product',
                countries: ['NL'],
                maxWeight: 2000,
                maxDimensions: {
                    length: 380,
                    width: 265,
                    height: 32
                },
                allowed: []
            },
            'Handtekening voor ontvangst': {
                allowed: ['Niet bij buren'],
                countries: ['NL']
            },
            'Niet bij buren': {
                allowed: ['Handtekening voor ontvangst'],
                countries: ['NL']
            }
        },
        logo: '/images/dhlLogo.png'
    },
    'DHL-QLS': {
        displayName: 'DHL',
        type: 'external',
        platform: 'QLS',
        countries: _.without(DHLCountries, 'GB', 'NO'), // QLS does not support GB and Norway for DHL
        maxWeight: 31500,
        maxDimensions: {
            length: 2400,
            width: 600,
            height: 600
        },
        maxVolume: 432,
        products: {
            'Aangetekend': {
                allowed: [],
                countries: ['NL']
            },
            'Afhaalpunt': {
                allowed: [],
                countries: ['NL']
            },
            'Avondlevering': {
                allowed: [],
                countries: ['NL']
            },
            'Brievenbuspakket': {
                type: 'product',
                countries: ['NL'],
                maxWeight: 2000,
                maxDimensions: {
                    length: 380,
                    width: 265,
                    height: 32
                },
                allowed: []
            },
            'Envelop': {
                type: 'product',
                countries: ['NL'],
                maxWeight: 500,
                maxDimensions: {
                    length: 380,
                    width: 265,
                    height: 32
                },
                allowed: []
            },
            'Handtekening voor ontvangst': {
                allowed: ['Niet bij buren'],
                countries: ['BE', 'NL']
            },
            'Leeftijdscheck 18+': {
                allowed: [],
                countries: ['NL']
            },
            'Niet bij buren': {
                allowed: ['Handtekening voor ontvangst'],
                countries: ['NL']
            },
            'Retour': {
                type: 'product',
                countries: ['BE', 'DE', 'NL'], // For retour parcels the receiver address and sender address is swapped so this actually is the sender country
                // countries: ['AT', 'BE', 'BG', 'CZ', 'DE', 'DK', 'EE', 'ES', 'FI', 'FR', 'GR', 'HR', 'HU', 'IE', 'IT', 'LT', 'LU', 'LV', 'NL', 'PL', 'PT', 'RO', 'SE', 'SI', 'SK'], // For retour parcels the receiver address and sender address is swapped so this actually is the sender country
                allowed: []
            },
            'Verzekerd': {
                countries: ['BE', 'NL'],
                allowed: [],
                values: [500]
            }
        },
        logo: '/images/dhlLogo.png'
    },
    'DPD-QLS': {
        displayName: 'DPD',
        type: 'external',
        platform: 'QLS',
        countries: ['BE', 'NL', 'AT', 'BG', 'CH', 'CZ', 'DE', 'DK', 'EE', 'ES', 'FI', 'FR',
            'GR', 'HR', 'HU', 'IE', 'IS', 'IT', 'LT', 'LU', 'LV',
            'NO', 'PL', 'PT', 'RO', 'RS', 'SE', 'SI', 'SK'],
        maxWeight: 31500,
        maxDimensions: {
            length: 1200,
            width: 600,
            height: 500
        },
        maxVolume: 360,
        products: {
            'Afhaalpunt': {
                allowed: [],
                countries: ['NL']
            },
            'Leeftijdscheck 18+': {
                allowed: [],
                countries: ['NL']
            },
            'Retour': {
                type: 'product',
                countries: ['BE', 'DE', 'NL'], // For retour parcels the receiver address and sender address is swapped so this actually is the sender country
                // countries: ['AT', 'BE', 'CH', 'CZ', 'DE', 'DK', 'EE', 'ES', 'FI', 'FR', 'HU', 'IS', 'LT', 'LU', 'LV', 'NL', 'NO', 'PL', 'PT', 'SE', 'SK'], // For retour parcels the receiver address and sender address is swapped so this actually is the sender country
                allowed: []
            }
        },
        logo: '/images/dpdLogo.png'
    },
    'DPD-onlineparcel': {
        displayName: 'DPD',
        type: 'external',
        platform: 'Onlineparcel',
        countries: ['NL', 'AT', 'BE', 'BG', 'HR', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE', 'BA', 'GG', 'IS', 'IM', 'JE', 'MC', 'NO', 'RS', 'CH', 'GB'],
        maxWeight: 31500,
        maxDimensions: {
            length: 1200,
            width: 600,
            height: 500
        },
        maxVolume: 360,
        products: {
            'Brievenbuspakket': {
                allowed: [],
                type: 'product',
                countries: ['NL', 'BE', 'FR', 'DE']
            },
            'Afhaalpunt': {
                allowed: [],
                countries: ['NL', 'BE']
            },
            'Handtekening voor ontvangst': {
                allowed: ['Verzekerd'],
                countries: ['NL', 'BE']
            },
            'Verzekerd': {
                allowed: ['Handtekening voor ontvangst'],
                countries: ['NL', 'AT', 'BE', 'BG', 'HR', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE', 'BA', 'GG', 'IS', 'IM', 'JE', 'MC', 'NO', 'RS', 'CH', 'GB'],
                values: [500]
            }
        },
        logo: '/images/dpdLogo.png'
    },
    'GLS': {
        displayName: 'GLS',
        type: 'external',
        countries: [...PostNLEUR1, ...PostNLEUR2, ...PostNLWereld],
        maxWeight: 32000,
        maxDimensions: {
            length: 2000,
            width: 800,
            height: 600
        },
        maxVolume: 960,
        products: {
            'Afhaalpunt': {
                allowed: ['Handtekening voor ontvangst'],
                countries: ['NL', 'AT', 'BE', 'BG', 'CZ', 'DE', 'DK', 'ES', 'FI', 'FR', 'GR', 'HR', 'HU', 'IT', 'LU', 'PL', 'PT', 'RO', 'SI', 'SK']
            },
            'Brievenbuspakket': {
                type: 'product',
                allowed: [],
                countries: ['NL'],
                maxWeight: 2000,
                maxDimensions: {
                    length: 380,
                    width: 265,
                    height: 32
                }
            },
            'Handtekening voor ontvangst': {
                allowed: ['Spoed levering', 'Afhaalpunt'],
                countries: ['NL']
            },
            'Pick & Ship': {
                allowed: [],
                countries: ['NL', ...PostNLEUR1, ...PostNLEUR2]
            },
            'Pick & Return': {
                allowed: [],
                countries: ['NL', ...PostNLEUR1, ...PostNLEUR2]
            },
            'Retour': {
                type: 'product',
                allowed: [],
                countries: ['NL'] // For retour parcels the receiver address and sender address is swapped so this actually is the sender country
            },
            'Spoed levering': {
                allowed: ['Handtekening voor ontvangst'],
                countries: ['NL'],
                values: ['09:00', '10:00', '12:00', '17:00', 'zaterdag 09:00', 'zaterdag 12:00', 'zaterdag 17:00']
            }
        },
        logo: '/images/glsLogo.png'
    },
    'Intrapost': {
        displayName: 'Intrapost',
        type: 'external',
        countries: _.pluck(COUNTRIES, 'code2'),
        maxWeight: 23000,
        maxDimensions: {
            length: 1000,
            width: 500,
            height: 500
        },
        products: {
            'Afhaalpunt': {
                allowed: [],
                countries: _.pluck(COUNTRIES, 'code2')
            },
            'Aangetekend': {
                allowed: [],
                countries: _.pluck(COUNTRIES, 'code2')
            },
            'Aangetekende brief': {
                type: 'product',
                allowed: [],
                countries: _.pluck(COUNTRIES, 'code2')
            },
            'Avondlevering': {
                allowed: [],
                countries: _.pluck(COUNTRIES, 'code2')
            },
            'Brievenbuspakket': {
                type: 'product',
                countries: _.pluck(COUNTRIES, 'code2'),
                maxWeight: 2000,
                maxDimensions: {
                    length: 380,
                    width: 265,
                    height: 32
                },
                allowed: []
            },
            'Envelop': {
                type: 'product',
                countries: _.pluck(COUNTRIES, 'code2'),
                maxWeight: 2000,
                maxDimensions: {
                    length: 380,
                    width: 265,
                    height: 32
                },
                allowed: []
            },
            'Handtekening voor ontvangst': {
                allowed: ['Niet bij buren'],
                countries: _.pluck(COUNTRIES, 'code2')
            },
            'Leeftijdscheck 18+': {
                allowed: [],
                countries: _.pluck(COUNTRIES, 'code2')
            },
            'Niet bij buren': {
                allowed: ['Handtekening voor ontvangst'],
                countries: _.pluck(COUNTRIES, 'code2')
            },
            'Verzekerd': {
                allowed: [],
                countries: _.pluck(COUNTRIES, 'code2'),
                values: [100, 250, 500, 1000, 1500, 2000, 2500, 3000, 3500, 4000, 4500, 5000]
            }
        },
        // Intrapost decides which carrier delivers the parcel, per product the reseller can choose which logo customers see
        labelCarriers: {
            DHL: {displayName: 'DHL', logo: '/images/dhlLogo.png'},
            Intrapost: {displayName: 'Intrapost', logo: '/images/intrapost.svg'}
            // PostNL: {displayName: 'PostNL', logo: '/images/postnlLogo.png', disabled: true} // Not available yet
        },
        logo: '/images/intrapost.svg'
    },
    'Packs': {
        displayName: 'Packs',
        type: 'external',
        countries: ['NL', 'BE', 'DE', 'FR', 'IT'],
        maxWeight: 35000,
        maxDimensions: {
            length: 2750,
            width: 1500,
            height: 1500
        },
        maxVolume: 6188,
        products: {
            'Brievenbuspakket': {
                type: 'product',
                allowed: [],
                countries: ['NL', 'BE'],
                maxWeight: 2000,
                maxDimensions: {
                    length: 380,
                    width: 265,
                    height: 32
                }
            },
            'Leeftijdscheck 18+': {
                allowed: ['Niet bij buren', 'Spoed levering'],
                countries: ['NL', 'BE']
            },
            'Niet bij buren': {
                allowed: ['Leeftijdscheck 18+', 'Spoed levering'],
                countries: ['NL', 'BE']
            },
            'Spoed levering': {
                allowed: ['Niet bij buren', 'Leeftijdscheck 18+'],
                countries: ['NL'],
                values: ['09:00', '12:00', '17:00']
            }
        },
        logo: '/images/packsLogo.png'
    },
    'Peddler': {
        displayName: 'Peddler',
        type: 'external',
        countries: ['NL'],
        maxWeight: 15000,
        maxDimensions: {
            length: 750,
            width: 500,
            height: 500
        },
        maxVolume: 188,
        products: {
            'Brievenbuspakket': {
                type: 'product',
                allowed: ['Same Day'],
                countries: ['NL'],
                maxWeight: 2000,
                maxDimensions: {
                    length: 380,
                    width: 265,
                    height: 32
                }
            },
            'Handtekening voor ontvangst': {
                allowed: ['Same Day'],
                countries: ['NL']
            },
            // 'Niet bij buren': {
            //     allowed: ['Handtekening voor ontvangst', 'Same Day'],
            //     countries: ['NL']
            // },
            'Same Day': {
                allowed: ['Brievenbuspakket', 'Handtekening voor ontvangst'],
                countries: ['NL']
            }
        },
        logo: '/images/peddlerLogo.png'
    },
    'PostNL': {
        displayName: 'PostNL',
        type: 'external',
        countries: [...PostNLEUR1, ...PostNLEUR2, ...PostNLWereld],
        maxWeight: 31500,
        maxDimensions: {
            length: 1750,
            width: 780,
            height: 580
        },
        maxVolume: 792,
        products: {
            'Aangetekend': {
                allowed: ['Antwoordnummer', 'Avondlevering', 'Postbus', 'Retour bij niet thuis', 'Spoed levering', 'Zondaglevering'],
                countries: ['NL']
            },
            'Aangetekende brief': {
                type: 'product',
                allowed: ['Antwoordnummer', 'Postbus'],
                countries: [...PostNLEUR1, ...PostNLEUR2, ...PostNLWereld],
                maxWeight: 2000,
                maxDimensions: {
                    length: 380,
                    width: 265,
                    height: 32
                }
            },
            'Adreslabel': {
                type: 'product',
                allowed: ['Antwoordnummer', 'Postbus'],
                countries: _.pluck(COUNTRIES, 'code2')
            },
            'Afhaalpunt': {
                allowed: [],
                countries: ['NL']
            },
            'Antwoordnummer': {
                type: 'product',
                allowed: ['Aangetekend', 'Aangetekende brief', 'Adreslabel', 'Brievenbuspakket', 'Handtekening voor ontvangst', 'Verzekerd'],
                countries: ['NL']
            },
            'Avondlevering': {
                allowed: ['Aangetekend', 'Handtekening voor ontvangst', 'Niet bij buren', 'Retour bij niet thuis', 'Verzekerd'],
                countries: ['NL']
            },
            'Brievenbuspakket': {
                type: 'product',
                allowed: ['Antwoordnummer', 'Postbus'],
                countries: ['AD', 'AT', 'AU', 'AX', 'BE', 'BG', 'BR', 'BY', 'CA', 'CH', 'CN', 'CY', 'CZ', 'DE', 'DK', 'EA', 'EE', 'ES', 'FI', 'FO', 'FR', 'GB', 'GI', 'GP', 'GR', 'GY', 'HK', 'HR', 'HU', 'IC', 'ID', 'IE', 'IL', 'IS', 'IT', 'JE', 'JP', 'KR', 'LB', 'LT', 'LU', 'LV', 'MA', 'MC', 'MQ', 'MT', 'MY', 'NL', 'NO', 'NZ', 'PL', 'PM', 'PT', 'RE', 'RO', 'RS', 'RU', 'SA', 'SE', 'SG', 'SI', 'SK', 'SM', 'TH', 'TR', 'UA', 'US', 'XA', 'XB', 'XM', 'XP', 'YT'],
                maxWeight: 2000,
                maxDimensions: {
                    length: 380,
                    width: 265,
                    height: 32
                }
            },
            'Brievenbuspakket 48 uurs': {
                type: 'product',
                allowed: ['Antwoordnummer', 'Postbus'],
                countries: ['NL'],
                maxWeight: 2000,
                maxDimensions: {
                    length: 380,
                    width: 265,
                    height: 32
                }
            },
            'Brievenbuspakket zonder Track & Trace': {
                type: 'product',
                allowed: [],
                countries: [...PostNLEUR1, ...PostNLEUR2, ...PostNLWereld],
                maxWeight: 2000,
                maxDimensions: {
                    length: 380,
                    width: 265,
                    height: 32
                }
            },
            'Handtekening voor ontvangst': {
                allowed: ['Antwoordnummer', 'Avondlevering', 'Niet bij buren', 'Postbus', 'Retour bij niet thuis', 'Spoed levering', 'Zondaglevering'],
                countries: [...PostNLEUR1, ...PostNLEUR2, ...PostNLWereld]
            },
            'Leeftijdscheck 18+': {
                allowed: ['Niet bij buren', 'Postbus', 'Verzekerd'],
                countries: ['NL']
            },
            'Niet bij buren': {
                allowed: ['Avondlevering', 'Handtekening voor ontvangst', 'Leeftijdscheck 18+', 'Retour bij niet thuis', 'Spoed levering', 'Zondaglevering'],
                countries: ['NL']
            },
            'Postbus': {
                allowed: ['Aangetekend', 'Aangetekende brief', 'Adreslabel', 'Brievenbuspakket', 'Handtekening voor ontvangst', 'Leeftijdscheck 18+', 'Verzekerd'],
                countries: ['BE', 'NL']
            },
            'Retour': {
                type: 'product',
                allowed: [],
                countries: ['NL']
            },
            'Retour bij niet thuis': {
                allowed: ['Aangetekend', 'Avondlevering', 'Handtekening voor ontvangst', 'Niet bij buren', 'Spoed levering', 'Verzekerd', 'Zondaglevering'],
                countries: ['NL']
            },
            'Spoed levering': {
                allowed: ['Aangetekend', 'Handtekening voor ontvangst', 'Niet bij buren', 'Retour bij niet thuis', 'Verzekerd'],
                countries: ['NL'],
                values: ['09:00', '10:00', '12:00', '17:00']
            },
            'Verspakket': {
                allowed: [],
                countries: ['NL']
            },
            'Verzekerd': {
                allowed: ['Antwoordnummer', 'Avondlevering', 'Leeftijdscheck 18+', 'Postbus', 'Retour bij niet thuis', 'Spoed levering', 'Verificatiecode', 'Zondaglevering'],
                countries: ['BE', 'NL'],
                values: [100, 250, 500, 1000, 1500, 2000, 2500, 3000, 3500, 4000, 4500, 5000]
            },
            'Verificatiecode': {
                allowed: ['Verzekerd'],
                countries: ['NL']
            },
            'Zondaglevering': {
                allowed: ['Aangetekend', 'Handtekening voor ontvangst', 'Niet bij buren', 'Retour bij niet thuis', 'Verzekerd'],
                countries: ['NL']
            }
        },
        logo: '/images/postnlLogo.png'
    },
    'PostNL-MSG': {
        displayName: 'PostNL',
        type: 'external',
        platform: 'Monta',
        countries: [...PostNLEUR1, ...PostNLEUR2, ...PostNLWereld],
        maxWeight: 31500,
        maxDimensions: {
            length: 1750,
            width: 780,
            height: 580
        },
        maxVolume: 792,
        products: {
            'Aangetekend': {
                allowed: ['Antwoordnummer', 'Avondlevering', 'Postbus'],
                countries: ['NL']
            },
            'Aangetekende brief': {
                type: 'product',
                allowed: ['Antwoordnummer', 'Postbus'],
                countries: ['NL'],
                maxWeight: 2000,
                maxDimensions: {
                    length: 380,
                    width: 265,
                    height: 32
                }
            },
            'Afhaalpunt': {
                allowed: [],
                countries: ['NL']
            },
            'Antwoordnummer': {
                type: 'product',
                allowed: ['Aangetekend', 'Aangetekende brief', 'Brievenbuspakket', 'Handtekening voor ontvangst'],
                countries: ['NL']
            },
            'Avondlevering': {
                allowed: ['Aangetekend', 'Handtekening voor ontvangst', 'Niet bij buren'],
                countries: ['NL']
            },
            'Brievenbuspakket': {
                type: 'product',
                allowed: ['Antwoordnummer', 'Postbus'],
                countries: ['AD', 'AT', 'AU', 'AX', 'BE', 'BG', 'BR', 'BY', 'CA', 'CH', 'CN', 'CY', 'CZ', 'DE', 'DK', 'EA', 'EE', 'ES', 'FI', 'FO', 'FR', 'GB', 'GI', 'GP', 'GR', 'GY', 'HK', 'HR', 'HU', 'IC', 'ID', 'IE', 'IL', 'IS', 'IT', 'JE', 'JP', 'KR', 'LB', 'LT', 'LU', 'LV', 'MA', 'MC', 'MQ', 'MT', 'MY', 'NL', 'NO', 'NZ', 'PL', 'PM', 'PT', 'RE', 'RO', 'RS', 'RU', 'SA', 'SE', 'SG', 'SI', 'SK', 'SM', 'TH', 'TR', 'UA', 'US', 'XA', 'XB', 'XM', 'XP', 'YT'],
                maxWeight: 2000,
                maxDimensions: {
                    length: 380,
                    width: 265,
                    height: 32
                }
            },
            'Handtekening voor ontvangst': {
                allowed: ['Antwoordnummer', 'Avondlevering', 'Niet bij buren', 'Postbus'],
                countries: [...PostNLEUR1, ...PostNLEUR2, ...PostNLWereld]
            },
            'Leeftijdscheck 18+': {
                allowed: ['Niet bij buren', 'Postbus'],
                countries: ['NL']
            },
            'Niet bij buren': {
                allowed: ['Avondlevering', 'Handtekening voor ontvangst', 'Leeftijdscheck 18+'],
                countries: ['NL']
            },
            'Postbus': {
                allowed: ['Aangetekend', 'Aangetekende brief', 'Brievenbuspakket', 'Handtekening voor ontvangst', 'Leeftijdscheck 18+'],
                countries: ['BE', 'NL']
            },
            'Verspakket': {
                allowed: [],
                countries: ['NL']
            }
        },
        logo: '/images/postnlLogo.png'
    },
    'PostNL-QLS': {
        displayName: 'PostNL',
        type: 'external',
        platform: 'QLS',
        countries: ['BE', 'NL'],
        maxWeight: 31500,
        maxDimensions: {
            length: 1750,
            width: 780,
            height: 580
        },
        maxVolume: 792,
        products: {
            'Aangetekend': {
                allowed: ['Postbus'],
                countries: ['NL']
            },
            'Aangetekende brief': {
                type: 'product',
                allowed: ['Postbus'],
                countries: ['NL'],
                maxWeight: 2000,
                maxDimensions: {
                    length: 380,
                    width: 265,
                    height: 32
                }
            },
            'Afhaalpunt': {
                allowed: ['Verzekerd'],
                countries: ['BE', 'NL']
            },
            'Avondlevering': {
                allowed: [],
                countries: ['NL']
            },
            'Brievenbuspakket': {
                type: 'product',
                allowed: ['Postbus'],
                countries: ['BE', 'NL'],
                maxWeight: 2000,
                maxDimensions: {
                    length: 380,
                    width: 265,
                    height: 32
                }
            },
            'Brievenbuspakket 48 uurs': {
                type: 'product',
                allowed: [],
                countries: ['NL'],
                maxWeight: 2000,
                maxDimensions: {
                    length: 380,
                    width: 265,
                    height: 32
                }
            },
            'Handtekening voor ontvangst': {
                allowed: ['Niet bij buren', 'Postbus'],
                countries: ['BE', 'NL']
            },
            'Leeftijdscheck 18+': {
                allowed: ['Niet bij buren', 'Verzekerd'],
                countries: ['NL']
            },
            'Niet bij buren': {
                allowed: ['Handtekening voor ontvangst', 'Leeftijdscheck 18+'],
                countries: ['BE', 'NL']
            },
            'Postbus': {
                allowed: ['Aangetekend', 'Aangetekende brief', 'Brievenbuspakket', 'Handtekening voor ontvangst', 'Leeftijdscheck 18+'],
                countries: ['BE', 'NL']
            },
            'Retour': {
                type: 'product',
                allowed: [],
                countries: ['BE', 'NL']// For retour parcels the receiver address and sender address is swapped so this actually is the sender country
            },
            'Verzekerd': {
                allowed: ['Afhaalpunt', 'Postbus', 'Leeftijdscheck 18+'],
                countries: ['BE', 'NL'],
                values: [100, 250, 500]
            }
        },
        logo: '/images/postnlLogo.png'
    },
    'PostNL-onlineparcel': {
        displayName: 'PostNL',
        type: 'external',
        platform: 'Onlineparcel',
        countries: ['NL', 'BE', 'AT', 'BG', 'CZ', 'DK', 'EE', 'FI', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE', 'AF', 'AL', 'DZ', 'AS', 'AD', 'AO', 'AI', 'AG', 'AR', 'AM', 'AW', 'AU', 'AZ', 'BS', 'BH', 'BD', 'BB', 'BZ', 'MC', 'NO', 'CH', 'GB', 'VI'],
        maxWeight: 31500,
        maxDimensions: {
            length: 1750,
            width: 780,
            height: 580
        },
        maxVolume: 792,
        products: {
            'Aangetekend': {
                allowed: [],
                countries: ['NL']
            },
            'Brievenbuspakket': {
                allowed: [],
                type: 'product',
                countries: ['NL'],
                maxWeight: 2000,
                maxDimensions: {
                    length: 380,
                    width: 265,
                    height: 32
                }
            },
            'Handtekening voor ontvangst': {
                allowed: ['Niet bij buren', 'Leeftijdscheck 18+', 'Verzekerd'],
                countries: ['NL']
            },
            'Leeftijdscheck 18+': {
                allowed: ['Handtekening voor ontvangst', 'Niet bij buren'],
                countries: ['NL']
            },
            'Niet bij buren': {
                allowed: ['Handtekening voor ontvangst', 'Leeftijdscheck 18+', 'Verzekerd'],
                countries: ['NL']
            },
            'Verzekerd': {
                allowed: ['Handtekening voor ontvangst', 'Niet bij buren'],
                countries: ['NL', 'BE', 'DE'],
                values: [100, 250, 500]
            },
            'Afhaalpunt': {
                allowed: [],
                countries: ['NL', 'BE']
            }
        },
        logo: '/images/postnlLogo.png'
    },
    'Skynet': {
        displayName: 'Skynet',
        type: 'external',
        countries: _.pluck(COUNTRIES, 'code2'),
        maxWeight: 30000,
        maxDimensions: {
            length: 1000,
            width: 500,
            height: 500
        },
        maxVolume: 250,
        products: {
            'Aangetekend': {
                allowed: ['Antwoordnummer', 'Postbus'],
                countries: ['NL']
            },
            'Antwoordnummer': {
                type: 'product',
                allowed: ['Aangetekend', 'Brievenbuspakket'],
                countries: ['NL']
            },
            'Brievenbuspakket': {
                type: 'product',
                allowed: ['Antwoordnummer', 'Postbus'],
                countries: ['NL', 'BE', 'DE', 'IT', 'FR', 'GB'],
                maxWeight: 2000,
                maxDimensions: {
                    length: 380,
                    width: 265,
                    height: 32
                }
            },
            'Postbus': {
                allowed: ['Aangetekend', 'Brievenbuspakket'],
                countries: ['BE', 'NL']
            },
            'Zonder Track & Trace': {
                type: 'product',
                allowed: [],
                countries: _.difference(_.pluck(COUNTRIES, 'code2'), ['NL'])
            }
        },
        logo: '/images/skynetLogo.png'
    },
    'sparqle': {
        displayName: 'Sparqle',
        type: 'external',
        countries: ['NL'],
        maxWeight: 20000,
        maxDimensions: {
            length: 1000,
            width: 1000,
            height: 1000
        },
        products: {
            'Afhaalpunt': {
                allowed: [],
                countries: ['NL']
            },
            'Handtekening voor ontvangst': {
                allowed: ['Niet bij buren'],
                countries: ['NL']
            },
            'Niet bij buren': {
                allowed: ['Handtekening voor ontvangst'],
                countries: ['NL']
            }
        },
        logo: '/images/sparqleLogo.png'
    }
}

_.keys(carriers).map((carrierName) => {
    carriers[carrierName].combinedProducts = generatecombinedProducts(carriers[carrierName])
    carriers[carrierName].combinedProductsValues = generatecombinedProductValues(carriers[carrierName])
})

export default carriers
